/* Customer support chat for the Shopify theme.
   The conversation itself runs on the Aging Backwards Wellness app. The conversation credential is
   kept in memory only and posted inside the request body: a custom header would need a cross-origin
   preflight that the hosting layer answers before this app sees it. */
(function () {
  "use strict";

  var APP = "https://aging-backwards-wellness.lovable.app";
  var root = document.querySelector("[data-ab-chat]");
  if (!root) return;

  var panel = root.querySelector("[data-ab-chat-panel]");
  var body = root.querySelector("[data-ab-chat-body]");
  var openButton = root.querySelector("[data-ab-chat-open]");
  var closeButton = root.querySelector("[data-ab-chat-close]");

  var token = "";
  var contact = null;
  var messages = [];
  var busy = false;
  var waiting = false;
  var error = "";
  var started = false;

  var pendingHuman = null;
  var contactSent = false;
  var dismissedAt = -1;
  var quiet = false;
  var quietTimer = null;
  var IDLE_MS = 180000;
  var everOffered = false;
  var offeredFor = -1;
  var CHOICES_HEADING = "Did this answer your question?";
  var CHOICES = [
    { label: "Yes, now I want to speak to a live human", human: true, message: "Yes, that answered my question. Now I'd like to speak to a live person from your team." },
    { label: "Yes, I have more questions to ask here", human: false, message: "" },
    { label: "No, I need to speak to a live human", human: true, message: "No, that didn't answer my question. I need to speak to a live person from your team." },
    { label: "No, and I don't have any other questions", human: false, message: "No, that didn't fully answer my question, and I don't have any other questions right now." }
  ];
  function startQuiet() {
    clearTimeout(quietTimer);
    quiet = false;
    quietTimer = setTimeout(function () {
      var area = body.querySelector(".ab-chat__textarea");
      if (area && area.value.trim()) return;
      quiet = true;
      if (!busy) show();
    }, IDLE_MS);
  }
  function offerChoices() {
    var last = messages[messages.length - 1];
    if (busy || !last || last.role !== "assistant" || dismissedAt === messages.length) return false;
    var asked = messages.filter(function (m) { return m.role === "user"; }).length;
    if (asked < 1) return false;
    if (quiet) return true;
    if (offeredFor === messages.length) return true;
    return !everOffered && asked >= 3;
  }

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character];
    });
  }

  /* A blocked cross-origin call only ever reports "Failed to fetch", so keep the shopper-facing
     wording friendly and explain the real cause in the console instead. */
  function friendly(reason, fallback) {
    var message = reason && reason.message ? String(reason.message) : "";
    if (!message || message === "Failed to fetch" || message.indexOf("NetworkError") !== -1) return fallback;
    return message;
  }

  /* The assistant writes links as [text](url); everything else stays plain text. */
  function rich(value) {
    return esc(value)
      .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (_match, label, href) {
        if (/^\/(?!\/)/.test(href)) return '<a href="' + href + '">' + label + "</a>";
        if (!/^(https?:|mailto:)/i.test(href)) return label;
        return '<a href="' + href + '" target="_blank" rel="noopener">' + label + "</a>";
      })
      .replace(/\n/g, "<br>");
  }

  function contactFrom(text) {
    var name = text.match(/^Name: (.+)$/m);
    var email = text.match(/^Email: (.+)$/m);
    if (!name || !email) return null;
    var parsed = { name: name[1].trim(), email: email[1].trim() };
    return parsed.name && EMAIL_PATTERN.test(parsed.email) ? parsed : null;
  }

  function questionWithContact(text) {
    if (!contact || contactSent) return text;
    contactSent = true;
    return "Name: " + contact.name + "\nEmail: " + contact.email + "\n\n" + text;
  }

  function show() {
    if (pendingHuman && !contact) { showContactForm(); return; }
    showConversation();
  }

  function showContactForm() {
    body.innerHTML =
      '<form class="ab-chat__form" novalidate>' +
      '<p class="ab-chat__intro">What’s your name and email address so a team member can reply?</p>' +
      '<label class="ab-chat__label" for="ab-chat-name">Name</label>' +
      '<input class="ab-chat__input" id="ab-chat-name" autocomplete="name" maxlength="100" required>' +
      '<label class="ab-chat__label" for="ab-chat-email">Email address</label>' +
      '<input class="ab-chat__input" id="ab-chat-email" type="email" autocomplete="email" maxlength="254" required>' +
      '<p class="ab-chat__hint">Used for your support conversation, not newsletter signup.</p>' +
      (error ? '<p class="ab-chat__error" role="alert">' + esc(error) + "</p>" : "") +
      '<button class="ab-chat__button" type="submit">Send to our team</button> <button class="ab-chat__link" type="button" data-ab-chat-cancel>Cancel</button>' +
      "</form>";

    var form = body.querySelector("form");
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var name = form.querySelector("#ab-chat-name").value.trim();
      var email = form.querySelector("#ab-chat-email").value.trim();
      if (!name || !EMAIL_PATTERN.test(email)) {
        error = "Please enter your name and a valid email address.";
        show();
        return;
      }
      contact = { name: name, email: email };
      error = "";
      var text = pendingHuman;
      pendingHuman = null;
      ask(text);
    });
    form.querySelector("[data-ab-chat-cancel]").addEventListener("click", function () { pendingHuman = null; show(); });
    var first = form.querySelector("input");
    if (first) first.focus();
  }

  function showConversation() {
    var html = '<div class="ab-chat__log" data-ab-chat-log>';
    if (!messages.length) html += '<p class="ab-chat__intro">Hi! Ask me about our formulas, the research behind them, your health goals, or shipping and returns.</p>';
    messages.forEach(function (message) {
      html += '<div class="ab-chat__msg ab-chat__msg--' + (message.role === "user" ? "me" : "ai") + '">' + rich(message.text.replace(/^Name: .*\nEmail: .*\n\n/, "")) + "</div>";
    });
    if (offerChoices()) {
      everOffered = true;
      offeredFor = messages.length;
      html += '<div class="ab-chat__choices" role="group" aria-label="' + CHOICES_HEADING + '">';
      html += '<p class="ab-chat__choices-heading">' + esc(CHOICES_HEADING) + "</p>";
      CHOICES.forEach(function (c, i) { html += '<button type="button" class="ab-chat__choice" data-ab-choice="' + i + '">' + esc(c.label) + "</button>"; });
      html += "</div>";
    }
    if (waiting) html += '<div class="ab-chat__msg ab-chat__msg--ai ab-chat__wait">Checking your question…</div>';
    if (error) html += '<p class="ab-chat__error" role="alert">' + esc(error) + "</p>";
    html += "</div>";
    html +=
      '<form class="ab-chat__composer">' +
      '<textarea class="ab-chat__textarea" rows="2" placeholder="Ask about products, research or shipping…" aria-label="Support question" maxlength="1600"></textarea>' +
      '<div class="ab-chat__actions"><button class="ab-chat__button" type="submit"' + (busy ? " disabled" : "") + ">Send</button></div>" +
      "</form>";
    body.innerHTML = html;

    var log = body.querySelector("[data-ab-chat-log]");
    if (log) log.scrollTop = log.scrollHeight;
    var form = body.querySelector(".ab-chat__composer");
    var area = body.querySelector(".ab-chat__textarea");
    Array.prototype.forEach.call(body.querySelectorAll("[data-ab-choice]"), function (button) {
      button.addEventListener("click", function () {
        var c = CHOICES[Number(button.getAttribute("data-ab-choice"))];
        dismissedAt = messages.length;
        quiet = false;
        startQuiet();
        if (!c.message) { show(); return; }
        if (c.human && !contact) { pendingHuman = c.message; show(); return; }
        ask(c.message);
      });
    });
    area.addEventListener("input", function () { if (area.value.trim()) clearTimeout(quietTimer); });
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      ask(area.value.trim());
    });
    area.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        ask(area.value.trim());
      }
    });
    area.focus();
  }

  function ask(text) {
    if (busy || !text || !token) return;
    busy = true;
    waiting = true;
    error = "";
    var question = questionWithContact(text);
    messages.push({ role: "user", text: question });
    showConversation();
    var area = body.querySelector(".ab-chat__textarea");
    if (area) area.value = "";

    fetch(APP + "/api/public/support/chat", {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      body: JSON.stringify({
        sessionToken: token,
        messages: [{ id: "m" + Date.now(), role: "user", parts: [{ type: "text", text: question }] }],
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(
            function (data) { throw new Error(data.error || "Support could not answer. Please email customer care."); },
            function () { throw new Error("Support could not answer. Please email customer care."); }
          );
        }
        return readStream(response);
      })
      .catch(function (reason) {
        error = friendly(reason, "Support could not answer. Please email customer care.");
      })
      .then(function () {
        busy = false;
        waiting = false;
        startQuiet();
        show();
      });
  }

  function applyEvent(payload, reply) {
    var event;
    try { event = JSON.parse(payload); } catch (_error) { return; }
    if (event.type === "text-delta" && typeof event.delta === "string") {
      reply.text += event.delta;
      var bubble = replyBubble();
      if (bubble) bubble.innerHTML = rich(reply.text);
      var log = body.querySelector("[data-ab-chat-log]");
      if (log) log.scrollTop = log.scrollHeight;
    } else if (event.type === "error") {
      error = typeof event.text === "string" ? event.text : "Support could not answer. Please email customer care.";
    }
  }

  var bubble = null;
  function replyBubble() {
    var log = body.querySelector("[data-ab-chat-log]");
    if (!log) return null;
    if (!bubble) {
      bubble = log.querySelector(".ab-chat__wait");
      if (bubble) bubble.classList.remove("ab-chat__wait");
      else {
        bubble = document.createElement("div");
        bubble.className = "ab-chat__msg ab-chat__msg--ai";
        log.appendChild(bubble);
      }
    }
    return bubble;
  }

  function readStream(response) {
    bubble = null;
    var reply = { role: "assistant", text: "" };
    messages.push(reply);
    if (!response.body || !response.body.getReader) {
      return response.text().then(function (text) {
        text.split("\n\n").forEach(function (chunk) {
          chunk.split("\n").forEach(function (line) {
            if (line.indexOf("data: ") === 0 && line.slice(6) !== "[DONE]") applyEvent(line.slice(6), reply);
          });
        });
        if (!reply.text) error = "Support could not answer. Please email customer care.";
      });
    }
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = "";
    function pump() {
      return reader.read().then(function (result) {
        if (result.done) {
          if (!reply.text && !error) error = "Support could not answer. Please email customer care.";
          return;
        }
        buffer += decoder.decode(result.value, { stream: true });
        var chunks = buffer.split("\n\n");
        buffer = chunks.pop();
        chunks.forEach(function (chunk) {
          chunk.split("\n").forEach(function (line) {
            if (line.indexOf("data: ") === 0 && line.slice(6) !== "[DONE]") applyEvent(line.slice(6), reply);
          });
        });
        return pump();
      });
    }
    return pump();
  }

  function startSession() {
    fetch(APP + "/api/public/support/session", {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      body: JSON.stringify(token ? { sessionToken: token } : {}),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.error || "Support is unavailable right now. Please email customer care.");
          return data;
        });
      })
      .then(function (data) {
        if (data.sessionToken) token = data.sessionToken;
        messages = (data.messages || []).map(function (message) {
          var text = (message.parts || []).filter(function (part) { return part.type === "text"; }).map(function (part) { return part.text || ""; }).join("\n");
          return { role: message.role === "user" ? "user" : "assistant", text: text };
        }).filter(function (message) { return message.text; });
        if (!contact) {
          messages.forEach(function (message) {
            if (message.role !== "user") return;
            var found = contactFrom(message.text);
            if (found) { contact = found; contactSent = true; }
          });
        }
        error = "";
        startQuiet();
        show();
      })
      .catch(function (reason) {
        error = friendly(reason, "Support is unavailable right now. Please email customer care.");
        show();
      });
  }

  openButton.addEventListener("click", function () {
    panel.hidden = false;
    root.classList.add("ab-chat--open");
    if (!started) {
      started = true;
      body.innerHTML = '<div class="ab-chat__loading">Opening your conversation…</div>';
      startSession();
    } else {
      show();
    }
    openButton.hidden = true;
  });

  closeButton.addEventListener("click", function () {
    panel.hidden = true;
    root.classList.remove("ab-chat--open");
    openButton.hidden = false;
  });
})();
